import styled from 'styled-components';
import { aiBorderStackingOrderGuard } from '../utils.js';

var StackingOrderGuard = styled.div.withConfig({
  displayName: "StackingOrderGuard",
  componentId: "sc-p69zc9-0"
})(["display:inline-block;", ";"], aiBorderStackingOrderGuard);

export { StackingOrderGuard };
